import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import SectionHeading from '../components/HomePage/SectionHeading'
import Hero from '../components/LandingPages/NewOffer/Hero'
import ShallowHeader from '../components/ShallowHeader'
import { useRef } from 'react'
import SectionSubText from '../components/HomePage/SectionSubText'
import BookACallButton from '../components/Buttons/Specials/BookACallButton'
import FirstIcon from '../Icons/landingpages/Sales/1.svg'
import SecondIcon from '../Icons/landingpages/Sales/2.svg'
import ThirdIcon from '../Icons/landingpages/Sales/3.svg'
import { first } from 'lodash'
import { GeneralAPI } from '../apis/GeneralAPI'
import SectionHeadingWrapper from '../components/HomePage/SectionHeadingWrapper'
import { Reviews } from '../components/HomePage/CustomersLoveUs'
import { ContainerWrapper } from '../components/Container'
import Rating from '../components/Rating'
import HomepageBookCallLeadModal from '../components/Modals/HomepageBookCallLeadModal'

import HomePageSlider from '../components/HomePage/HomePageSlider'

const NEW_OFFER_MODAL_PROPS = {
    meetingTitle: 'Book a Coaching Call',
    formName: 'First Time Client Offer Strategy Call',
}

const SingleTestimonial = ({ review }) => {
    return (
        <div
            className="md:py-16 md:px-4 md:flex md:flex-col justify-between items-center text-center
                    md:h-full p-2">
            <div className="bg-white p-6 border md:h-full flex flex-col shadow-olm shadow-md rounded-xl space-y-5 text-center justify-between items-center">
                {Number(review.ratings) > 0 && (
                    <Rating rating={Number(review.ratings)} />
                )}
                {review.text && (
                    <p className="md:text-base text-lg">{review.text}</p>
                )}
                {review.client.name && (
                    <h3 className="md:text-xl text-lg md:leading-10 leading-10 font-bold">
                        {review.client.name}
                    </h3>
                )}
                {review.client.photo && (
                    <img
                        src={review.client.photo.sizes.thumbnail}
                        alt={review.client.name}
                        height={review.client.photo.sizes['thumbnail-height']}
                        width={review.client.photo.sizes['thumbnail-width']}
                    />
                )}
            </div>
        </div>
    )
}

const Feature = ({ feature }) => {
    return (
        <div className="border-2 bg-white border-gray-200 rounded-xl py-10 shadow-md px-10 space-y-4">
            <img src={feature.image} className="m-auto h-40" />
            <div
                className="text-center bg-center bg-cover"
                style={{
                    backgroundImage: "url('/assets/landing/sales/bg.svg')",
                }}>
                <p className="font-brush text-6xl text-olm-black">
                    {feature.title}
                </p>
                <p className="font-brush text-2xl text-olm-black">
                    {feature.subtitle}
                </p>
            </div>
            <p
                className="text-center text-black"
                dangerouslySetInnerHTML={{
                    __html: feature.description,
                }}
            />
        </div>
    )
}

const features = [
    {
        image: '/assets/landing/new-offer/features/1.png',
        title: '$0.53',
        subtitle: 'per Postcard',
        description: 'Designed to grab attention <br/> and create urgency.',
    },
    {
        image: '/assets/landing/new-offer/features/2.png',
        title: '1500',
        subtitle: 'Free leads',
        description: 'Hand-picked and ready for <br/> direct mail success.',
    },
    {
        image: '/assets/landing/new-offer/features/3.png',
        title: 'Low',
        subtitle: 'Minimum',
        description: 'Only 500 postcards <br/> to get started.',
    },
]

const services = [
    {
        Icon: FirstIcon,
        title: 'High Open Rates',
        description: 'Designed to grab attention and create urgency.',
    },
    {
        Icon: SecondIcon,
        title: 'Proven Results',
        description:
            'Real estate professionals across the country swear by these templates.',
    },
    {
        Icon: ThirdIcon,
        title: 'Cost-Effective',
        description:
            'Cut costs, not results — reach more leads without breaking the bank.',
    },
]

const USPSales = ({ reviews }) => {
    const videoReviews = reviews.filter((review) => review.type === 'Video')

    const threeReviews = reviews
        .filter((review) => review.text != '' && review.type != 'Video')
        .slice(6, 9)

    const formRef = useRef(null)

    const handleApplyNow = () => {
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    return (
        <LandingPageWrapper paddingFromTop={false} sectionSpacing={false}>
            <ShallowHeader metaTitle={'Sales Landing Page'} />

            <div className="space-y-10 md:space-y-10">
                <Hero onApplyClick={handleApplyNow} />

                <div className="bg-light-yellow-gradient rounded-lg py-10">
                    <SectionHeading>
                        <div className="px-4"></div>
                        Why This Offer is Perfect for You
                    </SectionHeading>

                    <SectionSubText size="max-w-4xl">
                        <div className="-mt-6">
                            Scale your real estate business with this unbeatable
                            first-time offer—postage, labor, and costs included!
                        </div>
                    </SectionSubText>

                    <div className="max-w-4xl m-auto pt-4">
                        <div className="px-10 md:px-0 md:hidden">
                            <HomePageSlider>
                                {' '}
                                {features.map((feature, index) => {
                                    return (
                                        <Feature
                                            key={index}
                                            feature={feature}
                                        />
                                    )
                                })}{' '}
                            </HomePageSlider>
                        </div>
                        <div className="md:grid hidden md:grid-cols-3 px-10 md:px-0 space-y-10 md:space-y-0 gap-6">
                            {features.map((feature, index) => {
                                return <Feature key={index} feature={feature} />
                            })}
                        </div>

                        <div className="max-w-md m-auto py-10 w-11/12">
                            <BookACallButton
                                Modal={HomepageBookCallLeadModal}
                                modalProps={NEW_OFFER_MODAL_PROPS}>
                                Book A Call To Lock in Your Rates Today!
                            </BookACallButton>
                        </div>
                    </div>
                </div>

                <div className="max-w-5xl m-auto px-6 md:px-0">
                    <div className="md:grid md:grid-cols-2 items-center">
                        <div className="space-y-4">
                            <h3 className="text-5xl font-bold">
                                <span>Don’t Miss This</span>
                                <br />
                                <span className="olm-gradient-text">
                                    Limited-Time Opportunity!
                                </span>
                            </h3>
                            <p className="text-xl">
                                Book a call today to lock in this exclusive{' '}
                                <br /> price and supercharge your next campaign
                            </p>
                            <div className="max-w-md">
                                <BookACallButton
                                    Modal={HomepageBookCallLeadModal}
                                    modalProps={NEW_OFFER_MODAL_PROPS}>
                                    Book A Call To Lock in Your Rates Today!
                                </BookACallButton>
                            </div>
                        </div>
                        <div className="text-center md:text-left">
                            <img
                                src="/assets/landing/new-offer/act.png"
                                className="max-w-full"
                            />
                        </div>
                    </div>

                    <div className="text-center my-16 px-4">
                        <SectionHeading size="xl">
                            Why Choose Open Letter Marketing?
                        </SectionHeading>
                        <SectionSubText>
                            <b> Because they work. Period. </b>
                            <br />
                            💡 Here’s what makes our direct mail unbeatable:
                        </SectionSubText>
                    </div>

                    <div className="max-w-7xl mx-auto px-4 md:grid md:grid-cols-3 gap-6 justify-center">
                        {services.map((Service, index) => (
                            <div
                                key={index}
                                className={`p-6 text-center ${
                                    index < services.length - 1
                                        ? 'md:border-r-2 border-b-2 md:border-b-0 border-gray-200'
                                        : ''
                                }`}>
                                <div className="mb-8 text-center justify-center flex">
                                    <Service.Icon />
                                </div>
                                <h3 className="text-xl font-semibold text-olm-black mb-2">
                                    {Service.title}
                                </h3>
                                <p className="text-olm-new-black">
                                    {Service.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="bg-light-yellow-gradient rounded-lg py-10 ">
                    <SectionHeadingWrapper>
                        <SectionHeading size="xl">
                            But don&apos;t take <br className="md:hidden" /> our
                            word for it, <br />
                            hear it from them
                        </SectionHeading>
                    </SectionHeadingWrapper>

                    <ContainerWrapper>
                        <div className="max-w-xl m-auto">
                            <Reviews reviews={videoReviews} />
                        </div>

                        <div className="px-6 md:px-0 md:hidden my-20">
                            <HomePageSlider>
                                {threeReviews.map((review, index) => {
                                    return (
                                        review?.text && (
                                            <SingleTestimonial
                                                key={index}
                                                review={review}
                                            />
                                        )
                                    )
                                })}
                            </HomePageSlider>
                        </div>

                        <div className="md:grid hidden md:grid-cols-3 space-y-6 md:space-y-0 md:py-10 py-20 px-6">
                            {threeReviews.map((review, index) => {
                                return (
                                    review?.text && (
                                        <SingleTestimonial
                                            key={index}
                                            review={review}
                                        />
                                    )
                                )
                            })}
                        </div>

                        <div className="max-w-md m-auto text-center space-y-8 w-11/12">
                            <BookACallButton
                                Modal={HomepageBookCallLeadModal}
                                modalProps={NEW_OFFER_MODAL_PROPS}>
                                Book A Call To Lock in Your Rates Today!
                            </BookACallButton>
                        </div>
                    </ContainerWrapper>
                </div>
            </div>
        </LandingPageWrapper>
    )
}

export default USPSales

export async function getStaticProps() {
    const { acf: reviewsACF } = first(await GeneralAPI.getPageBySlug('reviews'))
    const reviews = reviewsACF?.reviews?.length > 0 ? reviewsACF.reviews : []

    return {
        props: {
            reviews,
            isComponent: false,
            disableHeaderLogoLink: true,
            hideTopNav: true,
            hideCartButton: true,
            hideLoginButton: true,
        },
        revalidate: 10, // In seconds
    }
}
